import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { Layout } from "@/components/Layout";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Magazine from "@/pages/Magazine";
import Articles from "@/pages/Articles";
import ArticleDetail from "@/pages/ArticleDetail";
import Library from "@/pages/Library";
import Research from "@/pages/Research";
import Gallery from "@/pages/Gallery";
import Initiatives from "@/pages/Initiatives";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import NotFound from "@/pages/NotFound";

const Site = ({ children }) => <Layout>{children}</Layout>;

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Site><Home /></Site>} />
          <Route path="/about" element={<Site><About /></Site>} />
          <Route path="/magazine" element={<Site><Magazine /></Site>} />
          <Route path="/articles" element={<Site><Articles /></Site>} />
          <Route path="/articles/:id" element={<Site><ArticleDetail /></Site>} />
          <Route path="/library" element={<Site><Library /></Site>} />
          <Route path="/research" element={<Site><Research /></Site>} />
          <Route path="/gallery" element={<Site><Gallery /></Site>} />
          <Route path="/initiatives" element={<Site><Initiatives /></Site>} />
          <Route path="/contact" element={<Site><Contact /></Site>} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="*" element={<Site><NotFound /></Site>} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </AuthProvider>
  );
}

export default App;
